/* eslint-disable no-restricted-imports */
import {
  CardContent as MuiCardContent,
  CardContentProps as MuiCardContentProps,
} from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { forwardRef } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:last-child': {
        paddingBottom: theme.spacing(2),
      },
    },
  })
);

type CardContentProps = MuiCardContentProps;

/**
 * Cards contain content and actions about a single subject.
 *
 * ```js
 * import { Card } from 'ui';
 * ```
 */
const CardContent = forwardRef<HTMLDivElement, CardContentProps>((props, ref) => {
  const classes = useStyles();
  return <MuiCardContent {...props} ref={ref} classes={{ root: classes.root }} />;
});

export default CardContent;
